module.exports = __webpack_public_path__ + "img/bg-pinmx.74ab1f20.jpg";